<script>
export default {
  props: {
    active: Number,
    sendVerifyResult: String
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value && value.length > 32) {
        return callback(new Error("密码长度不应超过32位"));
      } else if (value && value.length < 6) {
        return callback(new Error("密码长度不应小于6位"));
      } 
      setTimeout(() => {
        if (value.indexOf(' ')!=-1) {
          return callback(new Error("密码中不能使用空格"));
        }else{
          callback();
        }
      }, 1000);
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formChangePassword.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else if (value && value.length > 32) {
        return callback(new Error("密码长度不应超过32位"));
      } else if (value && value.length < 6) {
        return callback(new Error("密码长度不应小于6位"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      setTimeout(() => {
        if (!/^1(3|5|7|8|9)\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      verifyForm: {
        name: undefined,
        phoneNumber: undefined,
        verification: undefined
      },
      rules: {
        phoneNumber: [
          {
            required: true,
            validator: validateMobile,
            trigger: "change"
          }
        ],
        verification: [
          { required: true, message: "请填写验证码", trigger: "change" }
        ],
        name: [{ required: true, message: "请填写验证码", trigger: "change" }],
        newPassword: [
          {
            required: true,
            validator: validatePass,
            trigger: "change"
          }
        ],
        repetition: [
          {
            required: true,
            validator: validatePass2,
            trigger: "change"
          }
        ]
      },
      formChangePassword: {
        newPassword: undefined,
        repetition: undefined
      },
      sendMsgButton: true,
      sendMsgButtonTime: 0
    };
  },
  watch: {
    sendVerifyResult(verifyResult) {
      if (verifyResult === 'success') {
        this.sendMsgButton = false;
        this.sendMsgButtonTime = 60;
        var auth_timetimer = setInterval(() => {
          this.sendMsgButtonTime--;
          if (this.sendMsgButtonTime <= 0) {
            this.sendMsgButton = true;
            clearInterval(auth_timetimer);
          }
        }, 1000);
      } else {
        this.$message.success("手机号发送验证码失败，请检查手机号重新尝试！");
      }
    }
  },
  methods: {
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    async onClickSendMsg() {
      if (
        this.verifyForm.phoneNumber &&
        /^1(3|5|7|8|9)\d{9}$/.test(this.verifyForm.phoneNumber)
      ) {
        await this.$emit("sendSms", this.verifyForm.phoneNumber);
        console.log("verifyResult-->>>>", this.sendVerifyResult);
      } else {
        this.$message.success("新手机号未填写或格式不正确，请检查新手机号！");
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (formName === "verifyForm") {
            this.$emit("verifyCode", this.verifyForm);
          } else if (formName === "formChangePassword") {
            console.log(this.formChangePassword.newPassword)
            if(this.formChangePassword.newPassword==undefined){
              this.$message.error('密码不能为空');
              return false
            }else if(this.formChangePassword.repetition==undefined){
              this.$message.error('密码不能为空');
              return false
            }else if(this.formChangePassword.newPassword!=this.formChangePassword.repetition){
              this.$message.error('输入的密码不一致');
              return false
            }else if(this.formChangePassword.newPassword==''){
              this.$message.error('密码不能为空');
              return false
            }
            const formData = {
              phone: this.verifyForm.phoneNumber,
              code: this.verifyForm.verification,
              password: this.formChangePassword.newPassword,
              userName: this.verifyForm.name
            };
            this.$emit("submitNewPwd", formData);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm(formName) {
      this.centerDialogVisible = false;
      this.input = undefined;
      //   this.$refs[formName].resetFields();
    },
    RetrievePasswordSuccess() {
      this.$emit("successRetreve");
    }
  }
};
</script>

<template>
  <el-card shadow="never" class="findPasswordContent">
    <div slot="header" class="clearfix">
      <span class="findPasswordCardTitle">找回密码</span>
    </div>
    <el-steps :active="active" class="findPasswordSteps" align-center finish-status="success">
      <el-step title="验证身份"></el-step>
      <el-step title="重置登录密码"></el-step>
      <el-step title="重置成功"></el-step>
    </el-steps>
    <div v-if="active == 0" class="verifyUserView">
      <el-form
        label-position="right"
        :rules="rules"
        label-width="120px"
        :model="verifyForm"
        ref="verifyForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input class="basicFormInput" v-model="verifyForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phoneNumber">
          <el-input class="basicFormInput" v-model="verifyForm.phoneNumber" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="verification">
          <el-input class="sendMsgFormInput" v-model="verifyForm.verification" placeholder="手机验证码"></el-input>
          <el-button
            type="primary"
            v-if="sendMsgButton"
            class="operationButton"
            size="middle"
            @click="onClickSendMsg"
          >获取验证码</el-button>
          <el-button v-else size="middle" @click="onClickSendMsg" :disabled="!sendMsgButton">
            <span class="auth_text_blue">{{sendMsgButtonTime}}</span> 秒之重新发送验证码
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            class="operationButton submitButton"
            type="primary"
            @click="submitForm('verifyForm')"
          >下一步</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-else-if="active == 1" class="changeUserPasswordView">
      <el-form
        label-position="right"
        :rules="rules"
        label-width="110px"
        :model="formChangePassword"
        ref="formChangePassword"
      >
        <el-form-item label="姓名">
          <span class="basicFormInput">{{verifyForm.name }}</span>
        </el-form-item>
        <el-form-item label="手机号码">
          <span class="basicFormInput">{{verifyForm.phoneNumber }}</span>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            class="basicFormInput"
            show-password
            type="password"
            v-model="formChangePassword.newPassword"
            placeholder="密码长度不小于6位"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码确认" prop="repetition">
          <el-input
            class="basicFormInput"
            show-password
            type="password"
            v-model="formChangePassword.repetition"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="operationButton submitButton"
            type="primary"
            @click="submitForm('formChangePassword')"
          >下一步</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-else-if="active == 2" class="changePassWordSuccessView">
      <img src="./assets/finishedIcon.svg" />
      <div class="changePassWordSuccessText">您的登录密码修改成功</div>
      <el-button
        class="operationButton successButton"
        type="primary"
        @click="RetrievePasswordSuccess"
      >重新登录</el-button>
    </div>
    <!-- <el-button style="margin-top: 12px;" @click="next">下一步</el-button> -->
  </el-card>
</template>

<style lang="scss">
@import "@/css/color.scss";

.findPasswordContent {
  border: 0;
  width: 75%;
  margin: 35px auto;
  .findPasswordSteps {
    .is-process {
      .el-step__icon.is-text {
        border-color: #00c1de;
        background-color: #00c1de;
        color: #fff;
      }
    }
    .el-step__title.is-process {
      color: #00c1de;
    }
    .is-success {
      .el-step__icon.is-text {
        border-color: #00c1de;
        // background-color: #00c1de;
        color: #00c1de;
      }
      .el-step__line-inner {
        border-color: #00c1de;
        // background-color: #00c1de;
        color: #00c1de;
      }
    }
    .el-step__title.is-success {
      color: #00c1de;
    }
  }

  .verifyUserView {
    width: 500px;
    margin: 60px auto 0;
  }
  .changeUserPasswordView {
    width: 500px;
    margin: 60px auto 0;
  }
  .changePassWordSuccessView {
    width: 500px;
    margin: 60px auto 0;
    text-align: center;
    .changePassWordSuccessText {
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 40px;
    }
    > img {
      margin: 15px auto;
    }
    .successButton {
      margin: 15px auto;
    }
  }
  .el-form-item__error {
    left: 25px;
  }
  .basicFormInput {
    width: 250px;
    margin: 0 25px;
  }
  .sendMsgFormInput {
    width: 110px;
    margin: 0 25px;
  }
  .operationButton {
    background-color: #00c1de;
    border-color: #00c1de;
  }
  .submitButton {
    margin-left: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/RetrievePassword.vue